import { Select, SelectProps } from '@mantine/core';

import { useGetZipsQuery } from '@api/locations.api';

export default function ZipSelector(props: { city: string } & SelectProps) {
  const { data = [], isLoading } = useGetZipsQuery(props.city, {
    skip: props.disabled,
  });

  return (
    <Select
      label="CAP"
      placeholder="Seleziona CAP"
      data={data
        .toSorted((a, b) => (a.cap > b.cap ? 1 : -1))
        .map((city) => ({
          value: city.cap,
          label: city.cap,
        }))}
      searchable
      {...props}
      disabled={isLoading || props.disabled}
    />
  );
}
